import React, { forwardRef } from 'react'
import styled from 'styled-components'
import { inheritPrimaryColor } from '../colors'

const Contact = styled(forwardRef((props, ref) => {
  return (
    <div ref={ref} {...props}>
      <h1 css='margin: 10px;'>Contact Us</h1>
      <p css='margin: 10px;'>
        <b>Prof. Serena Nik-Zainal</b><br />
        Early Cancer Institute<br />
        University of Cambridge<br />
        Hutchison Research Centre<br />
        Box 197<br />
        Cambridge Biomedical Campus<br />
        Cambridge<br />
        United Kingdom<br />
        CB2 0XZ
      </p>
      <p css='margin: 10px; font-weight: bold'>
        <a css='color: white; text-decoration: none; &:hover { text-decoration: underline; }' href='mailto:sn206@cam.ac.uk'>sn206@cam.ac.uk</a>
      </p>
    </div>
  )
}))`
  color: white;
  background-color: ${inheritPrimaryColor};
  padding: 20px 20px 30px;
  display: flex;
  justify-content: space-evenly;
  flex-wrap: wrap;
`

export default Contact